import { render, staticRenderFns } from "./Vendas.vue?vue&type=template&id=2ed712d1&"
import script from "./Vendas.vue?vue&type=script&lang=js&"
export * from "./Vendas.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/lib/jenkins/workspace/taylor-minhasvendas-frontend-teste/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2ed712d1')) {
      api.createRecord('2ed712d1', component.options)
    } else {
      api.reload('2ed712d1', component.options)
    }
    module.hot.accept("./Vendas.vue?vue&type=template&id=2ed712d1&", function () {
      api.rerender('2ed712d1', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/Vendas.vue"
export default component.exports